import MuiTabs from '@mui/material/Tabs';

import { styled } from 'helpers';

import { TabsProps } from './';

export const Tabs = styled(MuiTabs)<TabsProps>`
  border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.main};
  min-height: 0;

  .MuiTabs-indicator {
    height: 4px;
  }

  .MuiTab-root {
    margin-right: ${({ theme }) => theme.spacing(5)};
    &:last-child {
      margin-right: 0;
    }
  }

  &.MuiTabs-vertical {
    .MuiTab-root {
      margin-right: 0;
    }
  }
`;
Tabs.displayName = 'Tabs';

export default Tabs;
